import { Permission } from '../pages/admin-roles-container/share-type'
import NoMatch from '../pages/not-match/no-match'
import { Navigate, useLocation } from 'react-router-dom'

const LoginRedirect = ({ backUrl }: { backUrl: string }) => {
  const location = useLocation()
  const redirect = encodeURIComponent(`${location.pathname}${location.search}`)
  const separator = backUrl.includes('?') ? '&' : '?'

  return <Navigate to={`${backUrl}${separator}redirect=${redirect}`} replace />
}

function AuthRoute(props: any) {
  const {
    user,
    backUrl,
    permission: routePermission,
    path,
    element,
    auth,
    accessToken,
    children,
    permissions,
    clientType,
    ...otherporps
  } = props
  if (auth && !accessToken) {
    if (clientType === 'studios-area') {
      return {
        path: '/studios-area/*',
        element: <LoginRedirect backUrl={backUrl} />,
      }
    } else if (clientType === 'admin') {
      return {
        path: '/*',
        element: <LoginRedirect backUrl={backUrl} />,
      }
    }
  }
  const getRoute = () => {
    if (children) {
      const authChildren = children.map((item: any) => {
        return AuthRoute({ ...item, user, accessToken, permissions })
      })
      return {
        path: path,
        element: element,
        children: authChildren,
        ...otherporps,
      }
    }
    return {
      path: path,
      element: element,
      ...otherporps,
    }
  }

  if (routePermission && permissions) {
    const userPermissions = permissions.map((item: Permission) => item.scope)
    if (userPermissions.indexOf(routePermission) > -1) {
      return getRoute()
    } else {
      return {
        path: '*',
        element: <NoMatch />,
      }
    }
  } else {
    return getRoute()
  }
}

export default AuthRoute
